var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "category d-flex d-flex-row flex-nowrap" }, [
      _c("div", { staticClass: "category-item verticalAlignMiddle" }, [
        _c("h2", [_vm._v(_vm._s(_vm.questionnaire.name))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "edit-item verticalAlignMiddle textAlignRight" },
        [
          _c(
            "a",
            {
              attrs: { href: "" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  _vm.active = !_vm.active
                }
              }
            },
            [_c("i", { staticClass: "fa fa-pencil" })]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("hr", { staticStyle: { "margin-bottom": "2px", "margin-top": "5px" } }),
    _vm._v(" "),
    _vm.active
      ? _c(
          "div",
          {
            staticClass:
              "category-content oldTableContainer oldContent width100"
          },
          [
            _c(
              "form",
              [
                _vm._l(_vm.questionListModel, function(questionModel) {
                  return questionModel.visible() &&
                    _vm.checkSocialMediaQuestionVisibility(questionModel, false)
                    ? _c(
                        "div",
                        {
                          key: questionModel.question.id,
                          class: [
                            {
                              compact: !questionModel.extended,
                              extended: questionModel.extended
                            },
                            "d-flex",
                            "d-flex-row",
                            "flex-wrap"
                          ]
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "label-item verticalAlignTop black500"
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(questionModel.question.questionText)
                                )
                              ]),
                              _vm.hasDescription(questionModel.question)
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: "" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          $event.preventDefault()
                                          questionModel.extended = !questionModel.extended
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass: "fa fa-info-circle"
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              questionModel.extended
                                ? _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        questionModel.question.description
                                      )
                                    }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "content-item verticalAlignTop lightGrey"
                            },
                            [
                              _vm.socialNetworks
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        _vm.getComponentName(
                                          questionModel.question
                                        ),
                                        {
                                          tag: "component",
                                          attrs: {
                                            item: _vm.getProfileItem(
                                              questionModel.question
                                            ),
                                            question: questionModel.question,
                                            socialnetworks: _vm.socialNetworks
                                          },
                                          on: { updateValue: _vm.updateValue }
                                        }
                                      )
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    [
                                      _c(
                                        _vm.getComponentName(
                                          questionModel.question
                                        ),
                                        {
                                          tag: "component",
                                          attrs: {
                                            item: _vm.getProfileItem(
                                              questionModel.question
                                            ),
                                            question: questionModel.question
                                          },
                                          on: { updateValue: _vm.updateValue }
                                        }
                                      )
                                    ],
                                    1
                                  )
                            ]
                          ),
                          _vm._v(" "),
                          _c("profileItemVisibilityEditor", {
                            attrs: {
                              item: _vm.getProfileItem(questionModel.question),
                              readOnly: !_vm.active
                            }
                          }),
                          _vm._v(" "),
                          questionModel.question.propertyInfo.key.value ===
                          "basis.socialnetworks.aktivneu"
                            ? _c("profileSocialMediaConnector", {
                                attrs: {
                                  item: _vm.getProfileItem(
                                    questionModel.question
                                  ),
                                  socialnetworks: _vm.socialNetworks,
                                  profileitems: _vm.getSocialMediaUrlProfileItems()
                                },
                                on: {
                                  updateSocialNetworks: _vm.getSocialNetworks,
                                  updateSocialNetworkUrlItem:
                                    _vm.updateSocialNetworkUrlItem
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "textAlignRight buttonBlockContainerRight" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-white teaserButton width100",
                        attrs: { type: "button" },
                        on: { click: _vm.cancel }
                      },
                      [_vm._v("Abbrechen")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        class: ["btn", "btn-white", "teaserButton", "width100"],
                        attrs: { type: "button", disabled: _vm.errors.any() },
                        on: { click: _vm.save }
                      },
                      [_c("span", [_vm._v("Speichern")])]
                    )
                  ]
                )
              ],
              2
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.active
      ? _c("div", { staticClass: "category-content" }, [
          _vm.socialNetworks
            ? _c(
                "div",
                { staticClass: "socialMedia" },
                [
                  _vm._l(_vm.questionListModel, function(questionModel) {
                    return questionModel.visible() &&
                      _vm.checkConnectedSocialMediaQuestionVisibility(
                        questionModel
                      )
                      ? _c(
                          "div",
                          {
                            key: questionModel.question.id,
                            class: [
                              {
                                compact: !questionModel.extended,
                                extended: questionModel.extended
                              },
                              "d-flex",
                              "d-flex-row",
                              "flex-wrap"
                            ]
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "label-item verticalAlignTop black500"
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(questionModel.question.questionText)
                                  )
                                ]),
                                _vm.hasDescription(questionModel.question)
                                  ? _c(
                                      "a",
                                      {
                                        attrs: { href: "" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            questionModel.extended = !questionModel.extended
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass: "fa fa-info-circle"
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                questionModel.extended
                                  ? _c("div", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          questionModel.question.description
                                        )
                                      }
                                    })
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content-item verticalAlignTop lightGrey"
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.getAnswerText(questionModel.question)
                                    )
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("profileItemVisibilityEditor", {
                              attrs: {
                                item: _vm.getProfileItem(
                                  questionModel.question
                                ),
                                readOnly: !_vm.active
                              }
                            }),
                            _vm._v(" "),
                            questionModel.question.propertyInfo.key.value ===
                            "basis.socialnetworks.aktivneu"
                              ? _c("profileSocialMediaConnector", {
                                  attrs: {
                                    item: _vm.getProfileItem(
                                      questionModel.question
                                    ),
                                    socialnetworks: _vm.socialNetworks,
                                    profileitems: _vm.getSocialMediaUrlProfileItems(),
                                    readonly: !_vm.active
                                  },
                                  on: {
                                    updateSocialNetworks: _vm.getSocialNetworks,
                                    updateSocialNetworkUrlItem:
                                      _vm.updateSocialNetworkUrlItem
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.questionListModel, function(questionModel) {
                    return questionModel.visible() &&
                      _vm.checkSocialMediaQuestionVisibility(
                        questionModel,
                        true
                      )
                      ? _c(
                          "div",
                          {
                            key: questionModel.question.id,
                            class: [
                              {
                                compact: !questionModel.extended,
                                extended: questionModel.extended
                              },
                              "d-flex",
                              "d-flex-row",
                              "flex-wrap"
                            ]
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "label-item verticalAlignTop black500"
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(questionModel.question.questionText)
                                  )
                                ]),
                                _vm.hasDescription(questionModel.question)
                                  ? _c(
                                      "a",
                                      {
                                        attrs: { href: "" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            questionModel.extended = !questionModel.extended
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass: "fa fa-info-circle"
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                questionModel.extended
                                  ? _c("div", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          questionModel.question.description
                                        )
                                      }
                                    })
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content-item verticalAlignTop lightGrey"
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.getAnswerText(questionModel.question)
                                    )
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("profileItemVisibilityEditor", {
                              attrs: {
                                item: _vm.getProfileItem(
                                  questionModel.question
                                ),
                                readOnly: !_vm.active
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  })
                ],
                2
              )
            : _c(
                "div",
                _vm._l(_vm.questionListModel, function(questionModel) {
                  return questionModel.visible()
                    ? _c(
                        "div",
                        {
                          key: questionModel.question.id,
                          class: [
                            {
                              compact: !questionModel.extended,
                              extended: questionModel.extended
                            },
                            "d-flex",
                            "d-flex-row",
                            "flex-wrap"
                          ]
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "label-item verticalAlignTop black500"
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(questionModel.question.questionText)
                                )
                              ]),
                              _vm.hasDescription(questionModel.question)
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: "" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          $event.preventDefault()
                                          questionModel.extended = !questionModel.extended
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass: "fa fa-info-circle"
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              questionModel.extended
                                ? _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        questionModel.question.description
                                      )
                                    }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "content-item verticalAlignTop lightGrey"
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getAnswerText(questionModel.question)
                                  )
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("profileItemVisibilityEditor", {
                            attrs: {
                              item: _vm.getProfileItem(questionModel.question),
                              readOnly: !_vm.active
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                })
              )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6902f06a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6902f06a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileSurveyEditor.vue
// module id = 582
// module chunks = 2